import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileDown, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { useAuth } from '../../context/AuthContext';
import { downloadSplitSeasonReport } from '../../utils/splitSeasonPdf';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Season + apiary pickers and a PDF download for the Split Season Report
export const SplitSeasonReportControls = () => {
  const { user } = useAuth();
  const [opts, setOpts] = useState({ seasons: [], yards: [] });
  const [season, setSeason] = useState('');
  const [yard, setYard] = useState('all');
  const [busy, setBusy] = useState(false);
  const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };

  useEffect(() => {
    axios.get(`${API}/hive-splits/season-report`, { headers })
      .then(res => { setOpts({ seasons: res.data.seasons, yards: res.data.yards }); setSeason(res.data.season); })
      .catch(() => {});
  }, []);

  const download = async () => {
    setBusy(true);
    try {
      const res = await axios.get(`${API}/hive-splits/season-report`, { headers, params: { season, yard } });
      await downloadSplitSeasonReport({ report: res.data, apiaryLabel: yard === 'all' ? 'All Apiaries' : yard, ownerName: user?.name, businessName: user?.business_name });
      toast.success('Split season report downloaded');
    } catch {
      toast.error('Could not create the report');
    } finally {
      setBusy(false);
    }
  };

  if (!opts.seasons.length) return null;
  const selectCls = 'border border-stone-300 rounded-lg px-2 py-1.5 text-sm bg-white';

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="split-season-report-controls">
      <span className="text-xs font-semibold uppercase tracking-wide text-stone-500">Printable season report</span>
      <select value={season} onChange={e => setSeason(e.target.value)} className={selectCls} aria-label="Season" data-testid="split-report-season">
        {opts.seasons.map(s => <option key={s} value={s}>Season {s.replace('-', '/')}</option>)}
      </select>
      <select value={yard} onChange={e => setYard(e.target.value)} className={selectCls} aria-label="Apiary" data-testid="split-report-apiary">
        <option value="all">All Apiaries</option>
        {opts.yards.map(y => <option key={y} value={y}>{y}</option>)}
      </select>
      <Button size="sm" variant="outline" onClick={download} disabled={busy} data-testid="split-report-download">
        {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <FileDown className="h-4 w-4 mr-1" />} Season PDF
      </Button>
    </div>
  );
};

export default SplitSeasonReportControls;
